import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmationDialog } from '../../ui';

/**
 * Confirmation dialog for sending a request payment to a client whose sms is disabled
 */

export default function RequestPaymentSmsDisabledDialog(props) {
  const {
    onConfirm,
  } = props;

  return (
    <ConfirmationDialog
      show
      title="Your client does not have text notifications enabled!"
      description="To charge your client for this appointment, you need to check them out manually"
      confirmText="Got It"
      onConfirm={onConfirm}
    />
  );
}

RequestPaymentSmsDisabledDialog.propTypes = {
  /** Callback fired when the confirm button is clicked. */
  onConfirm: PropTypes.func.isRequired,
};
